import './index.css'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/styles'
import AriaTheme from './themes/aria'

ReactDOM.render(
  <ThemeProvider theme={AriaTheme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
  ,
  document.getElementById('root')
)
